export const SET_VIEW_WIDTH = 'SET_VIEW_WIDTH'
export const SET_SHOW_AUTHOR_ANNOTATIONS = 'SET_SHOW_AUTHOR_ANNOTATIONS'
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION'
export const SET_HEADINGS = 'SET_HEADINGS'
